/* global axios */
import ApiClient from './ApiClient';

class SaleTypesAPI extends ApiClient {
  constructor() {
    super('sale_types', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(types) {
    return axios.patch(this.url, { sale_types: types });
  }
}

export default new SaleTypesAPI();
